/*globals jQuery, document */

jQuery(function ($) {
    $(document).ready(function() {
        var descriptionArea = $('#form-widgets-IBasic-description, #form-widgets-INewsItemBasic-description');
        var newsitem = $('#form-widgets-INewsItemBasic-description');

        if(descriptionArea.length) {
            var setDescriptionInfo = function(charsLeft, errEl, infoEl, isEn) {
                errEl.toggleClass('error', (charsLeft < 0));
                if(isEn) {
                    infoEl.html(charsLeft + ' characters remaining');
                } else {
                    infoEl.html('Nog ' + charsLeft + ' tekens');
                }
            };

            var text_max = (newsitem) ? 250 : 156;
            var description = $('#formfield-form-widgets-IBasic-description');
            var lang_en = $('body').hasClass('site-en');

            var text_remaining = text_max - (descriptionArea.val().length);
            var remaining = $('<div id="description_remaining"></div>').insertAfter(descriptionArea);

            setDescriptionInfo(text_remaining, description, remaining, lang_en);

            descriptionArea.keyup(function() {
                var text_length = descriptionArea.val().length;
                var text_remaining = text_max - text_length;
                setDescriptionInfo(text_remaining, description, remaining, lang_en);
            });
        }
    });
});
